import { getCookie } from 'lib/cookies';
import axiosInstance from 'configs/axiosConfig';

const config = () => {
  return {
    headers: {
      'Authorization': `Bearer ${getCookie('access')}`,
      'Set-Cookie': getCookie('refresh'),
    },
  };
};

export function getRecentQnAList() {
  return axiosInstance.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_BOARD_QNA_API}/dashboard`, config());
}

export function getAllQnAs() {
  return axiosInstance.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_BOARD_QNA_API}`, config());
}

export function updateQnAById(dataToSubmit) {
  return axiosInstance.patch(`${process.env.REACT_APP_URI}${process.env.REACT_APP_BOARD_QNA_API}`, dataToSubmit, config());
}
